module.exports = __webpack_public_path__ + "static/media/category.6114fc2f.svg";